// extracted by mini-css-extract-plugin
export default {"askQuestionTopText":"r4-z","yourQuestionLabel":"s4-z","notAuthedMessage":"t4-z","form":"u4-z","textarea":"v4-z","error":"w4-z","disabled":"x4-z","edited":"y4-z","submit":"z4-z"};